import { dynamicReportApi } from '../../../services/api/dynamicReportApi/dynamicReportApi';
import { queryClient } from '../../../services/query';
import { addIndication } from '../../taboola-common-frontend-modules/Indications';
import { saveDynamicReportError, saveDynamicReportSuccess } from '../actions/saveDynamicReport';
import { getErrorIndication, getSuccessIndication } from '../hooks/useDynamicReport';
import { DYNAMIC_REPORT_QUERY_PREFIX } from '../hooks/useDynamicReportCache';

export const saveDynamicReport =
    ({ accountName, accountId, reportId, dynamicReport }) =>
    async dispatch => {
        try {
            const response = await dynamicReportApi.updateReport(accountName, reportId, dynamicReport);
            dispatch(saveDynamicReportSuccess({ ...response, id: reportId }));
            dispatch(
                addIndication(getSuccessIndication(response.name, 'dynamic.reports.dynamic.report.update.success'))
            );

            const cachedReport = queryClient.getQueryData([DYNAMIC_REPORT_QUERY_PREFIX, `${accountId}`, `${reportId}`]);
            if (cachedReport?.id === reportId) {
                queryClient.setQueryData([DYNAMIC_REPORT_QUERY_PREFIX, `${accountId}`, `${reportId}`], {
                    ...cachedReport,
                    ...response,
                });
            }
        } catch {
            dispatch(saveDynamicReportError({ id: reportId }));
            dispatch(addIndication(getErrorIndication(reportId, 'dynamic.reports.dynamic.report.update.failure')));
        }
    };
